import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import React, { Component } from "react";

import Card from "@mui/material/Card";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from "@mui/material";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import {  Divider } from "@mui/material";
import wyzrTheme from "../../../styles/customTheme";
import { bugdetList } from "../../../utils/mockData";
import { TextField } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import PoundIcon from "../../../images/pound.png";
import { getURLBase, updateHeightAfterContentUpdate } from "../../../utils/helperFns";
import LoaderBlock from "../LoaderBlock";
import ShoppingCart from '../../../images/shopping-cart.png';
import Icon2 from "../../../images/3 82.svg";
import Icon3 from "../../../images/3 83.svg";
import Icon4 from "../../../images/3 84.svg";
import Icon5 from "../../../images/4 74.svg";
import Icon6 from "../../../images/5 2.svg";
import Icon7 from "../../../images/7 11.svg";
import axios from "axios";

const images = {
    ShoppingCart: ShoppingCart,
    Icon2: Icon2,
    Icon3: Icon3,
    Icon4: Icon4,
    Icon5: Icon5,
    Icon6: Icon6,
    Icon7: Icon7
}

export class EditBudget extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/budget/edit";
        this.state = {
            isReady: false,
            budgetCategories: [],
            originalBudgetCategories : bugdetList
        };
    }

    componentDidMount() {
        axios.post(this.url, { gid: this.props.gid }).then(res => {
            this.setState({
                budgetCategories: res.data.body.data,
                isReady: true,
            });
        });
    }

    updateValue = (value, index) => {
        var budgetList = this.state.budgetCategories;
        budgetList[index].spent = value;
        this.setState({budgetCategories:budgetList})
    }

    closeScreen = () => {
        var budgetList = this.state.budgetCategories;
        var originalList = this.state.originalBudgetCategories;
        budgetList.forEach((el,i) => {
            if(el.spent < 0) el.spent = originalList[i].spent;
        });
        this.setState({budgetCategories:budgetList})
        this.props.toggleHandler();
    }

    render() {
        return (
            <Card className="popup" id="child_EditBudget">
                <Box className="popupClose">
                    <IconButton aria-label="Close" onClick={this.closeScreen}>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                <Box className="popupHeader">
                    <Typography variant="h4" align="center" fontWeight={800} gutterBottom>BUDGET EDIT</Typography>
                    <Divider light />
                </Box>
                <Box className="popupBody" paddingX={2}>
                    <Grid container maxWidth="sm" marginX="auto" marginBottom={4}>
                        <Typography marginX="auto" marginTop={2} marginBottom={4} variant="subtitle1" align="center" color="text.secondary" gutterBottom> Suggested budgets based on your past
                            spending behaviour.</Typography>


                        <Grid container justifyContent="end">
                            <Grid item xs={12}>
                                <Typography variant="h6" align="right" gutterBottom>Miscellaneous Spends budget</Typography>
                            </Grid>
                        </Grid>
                        { this.state.budgetCategories.length ? this.state.budgetCategories.map((el, index) => (
                            <Grid container key={`editBudgetItem-${index}`} alignItems={"start"} marginTop={3}>
                                <Grid item xs={6}>
                                    <Stack direction="row" gap={2}>
                                        <img src={images[el.icon]} alt={el.title} style={{ height: 30 }} />
                                        <Stack>
                                            <Typography
                                                variant="h6"
                                                fontWeight="800"
                                               
                                                color="text.primary"
                                            >{el.title}</Typography>
                                            <Typography
                                                variant="subtitle2"
                                                color="text.secondary"
                                                marginBottom={0}

                                            >total budget £{el.budgetAmount}</Typography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={6} flexDirection={"column"} textAlign="right">
                            <Box>
                            <TextField className="editBudget" id={`editBudget-${index}`} sx={{ textAlign: "right" }}
                                    onChange={(e) => this.updateValue(e.target.value,index)}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img height={14} width={14} src={PoundIcon} alt="icon" />
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="standard" value={el.spent} type="number"
                                    />
                                    {
                                        el.spent < 0 ? <Typography display={"block"} variant='caption' color={wyzrTheme.palette.error.light}>Above value can't be negative</Typography> : null
                                    }
                            </Box>
                                   
                                </Grid>
                            </Grid>
                        )) : <LoaderBlock></LoaderBlock>  }
                    </Grid>
                </Box>
                {updateHeightAfterContentUpdate("child_BudgetCategory", "child_EditBudget", "parent_BudgetBreakdown")}
            </Card>
        );
    }
}

export default EditBudget;






